export default __webpack_public_path__ + "static/media/GIfs-icon.ab59530f.gif";